export const resources = {
  labelCancel: "Cancel",
  labelApprove: "Ok",
};
